<template>
    <WrapBg title="签约结果" bgImg="chargeBg">
        <div class="text-center text-success">
            <i class="el-icon-success" style="font-size:80px;margin:50px 0 30px;"></i>
            <div>签约成功</div>
        </div>
    </WrapBg>
</template>

<script>
    export default {
        name: "agreementsSuccess",
        created() {
            if(this.$route.query.payPrdCode != 'A37' && this.$route.query.payPrdCode != 'A38'){
                let appLink = localStorage.getItem('appLink');
                localStorage.removeItem('appLink');
                if(appLink) window.location.href = appLink;
            }
        }
    }
</script>

<style scoped>

</style>